module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"For example: travel destination, season, trip type...","new":"Add keyword..."},"de":{"title":"Zum Beispiel: Reiseziele, Jahreszeit, Art der Reise...","new":"Schlüsselwort hinzufügen..."}}')
  delete Component.options._Ctor
}
